<template>
  <div>
    <content-panel>
      <template v-slot:search>
        <search-box class="search-box">
          <el-form :inline="true" size="mini" :model="searchForm" label-width="100px" class="demo-form-inline">
            <el-form-item label="商品编码:"><el-input v-model.trim="searchForm.filterData.goodsCode" placeholder="商品编码(SKU)" /></el-form-item>
            <el-form-item label="商品名称:"><el-input v-model.trim="searchForm.filterData.goodsName" placeholder="商品名称(SKU)" /></el-form-item>
            <el-form-item label="销售状态:">
              <el-select v-model="searchForm.filterData.saleStatus" placeholder="全部">
                <el-option label="全部" value="" />
                <el-option v-for="item in saleStatusList" :label="item.saleStatus" :key="item.saleStatus" :value="item.saleStatus"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="商品定位:">
              <el-select v-model="searchForm.filterData.goodsLocation" filterable placeholder="全部">
                <el-option label="全部" value="" />
                <el-option v-for="item in goodsLocationSelect" :label="item.optionValue" :key="item.optionValue" :value="item.optionValue"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="空间:">
              <el-select v-model="searchForm.filterData.space" filterable placeholder="全部">
                <el-option label="全部" value="" />
                <el-option v-for="item in goodsPlaceSelect" :label="item.optionValue" :key="item.optionValue" :value="item.optionValue"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="品类:">
              <el-select v-model="searchForm.filterData.category" filterable placeholder="全部">
                <el-option label="全部" value="" />
                <el-option v-for="item in categoryList" :label="item.optionValue" :key="item.optionValue" :value="item.optionValue"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否组合:">
              <el-select v-model="searchForm.filterData.combination" placeholder="全部">
                <el-option label="全部" value="" />
                <el-option label="是" value="true" />
                <el-option label="否" value="false" />
              </el-select>
            </el-form-item>
            <el-form-item label="风格:">
              <el-select v-model="searchForm.filterData.style" filterable placeholder="全部">
                <el-option label="全部" value="" />
                <el-option v-for="item in styleList" :label="item.optionValue" :key="item.optionValue" :value="item.optionValue"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否清仓:">
              <el-select v-model="searchForm.filterData.clearance" placeholder="全部">
                <el-option label="全部" value="" />
                <el-option label="是" value="是" />
                <el-option label="否" value="否" />
                <el-option label="-" value="-" />
              </el-select>
            </el-form-item>
            <el-form-item label="上市时间:">
              <el-date-picker
                v-model="marketOnDateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                unlink-panels
                @change="onDateRangeChange"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="图片:">
              <el-select v-model="searchForm.filterData.imgExist" placeholder="全部">
                <el-option label="全部" value="" />
                <el-option label="有" value="true" />
                <el-option label="无" value="false" />
              </el-select>
            </el-form-item>
            <el-form-item label="所属类型:">
              <el-select v-model="searchForm.filterData.type">
                <el-option label="全部" value=""/>
                <el-option
                  v-for="item in types"
                  :key="item"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="所属店铺:">
              <el-select v-model="searchForm.filterData.aclass" filterable>
                <el-option label="全部" value=""/>
                <el-option
                  v-for="(item, index) in shopOptions"
                  :key="index"
                  :label="item.shopName"
                  :value="item.shopName">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否含松木:">
              <el-select v-model="searchForm.filterData.containsPine">
                <el-option label="全部" value=""/>
                <el-option label="是" value="是"></el-option>
                <el-option label="否" value="否"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="在售店铺:" class="checkbox">
              <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
              <el-checkbox-group v-model="checkStores" @change="handleCheckedStoreChange" style="display: inline-block; margin-left: 10px;">
                <el-checkbox v-for="item in stores" :label="item.id" :key="item.id">{{ item.optionValue }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="是否异常:">
              <el-select v-model="searchForm.filterData.goodsCodeError">
                <el-option label="全部" value=""/>
                <el-option label="是" value="是"></el-option>
                <el-option label="否" value="否"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="SKU推广名称:" label-width="110px">
              <el-input v-model="searchForm.filterData.work"></el-input>
            </el-form-item>
          </el-form>
          <template v-slot:right>
            <el-button type="primary" @click="criteriaSearch" size="small">搜索</el-button>
            <el-button @click="reset" size="small" class="orange-btn">重置</el-button>
          </template>
        </search-box>
      </template>

      <table-panel ref="tablePanel">
        <template v-slot:header-right>
          <el-button type="primary" size="mini" @click="$router.push('/shippingPeriod/skus')">发货周期查询</el-button>
          <el-button
            type="primary"
            @click="exportExcel"
            size="mini"
            v-loading.fullscreen.lock="loadingExport"
            element-loading-text="数据导出中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
          >
            导出
          </el-button>
          <el-button type="primary"  size="mini" @click="tableVisible = true">表格设置</el-button>
        </template>

        <el-table
          v-loading="loading"
          element-loading-text="数据加载中"
          element-loading-spinner="el-icon-loading"
          ref="table"
          :header-cell-style="{ backgroundColor: '#F4F8FB' }"
          :data="tableData.records"
          border
          :height="maxTableHeight"
          v-if="tableReload"
        >
          <el-table-column
            :fixed="item.fixed"
            :label="item.label"
            :prop="item.prop"
            :min-width="item.width"
            :sortable="item.sortable ? 'custom' : false"
            show-overflow-tooltip
            v-for="item in periodColumns" :key="item.prop"
          >
            <template slot-scope="scope">
              <template v-if="item.label==='图片'">
                <el-button v-if="scope.row.imgUrlList" size="mini" type="text" @click="viewImg(scope.row)">查看</el-button>                
              </template>
              <template v-else-if="item.prop === 'shippingPeriod'">
                <period-cell type="sku" :code="scope.row.goodsCode || scope.row.skuCode" :value="scope.row.deliveryCycle" :record="scope.row" />
              </template>
              <template v-else-if="item.label==='商品编码'">
                <el-tag size="mini" type="danger" v-if="scope.row.adapterMattress === '异常'">异常</el-tag>
                {{scope.row[item.prop]}}
              </template>
              <template v-else>
                {{scope.row[item.prop]}}
              </template>
            </template>
          </el-table-column>
        </el-table>

        <template v-slot:footer>
          <div style="text-align: right;">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="tableData.pageNum"
              :page-sizes="[30, 100, 500, 1000]"
              :page-size="tableData.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              background
              :total="tableData.total"
            ></el-pagination>
          </div>
        </template>
      </table-panel>
    </content-panel>
    <!--   图片展示   -->
    <el-dialog :visible.sync="imgFormVisible" @closed="clearImg">
      <el-image :src="imgUrl" fit="fill" style="max-width: 70%;max-height: 70%;display: block; margin: 0 auto;" />
    </el-dialog>
    <!--     SKU编辑 -->
    <el-dialog title="商品编辑" :visible.sync="editFormVisible" :close-on-click-modal="false" @close="editClose">
      <el-form :model="editData" :inline="true" ref="editData">
        <el-row :gutter="10" type="flex" justify="space-around">
          <el-col :span="20" :offset="1">
            <el-form-item label="商品编码">
              <el-tooltip effect="dark" :content="editData.goodsCode" placement="top">
                <div class="wrap_tooltip">
                  <span>{{ editData.goodsCode }}</span>
                </div>
              </el-tooltip>
            </el-form-item>
          </el-col>
          <el-col :span="20">
            <el-form-item label="商品名称">
              <el-tooltip effect="dark" :content="editData.goodsName" placement="top">
                <div class="wrap_tooltip">
                  <span>{{ editData.goodsCode }}</span>
                </div>
              </el-tooltip>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10" type="flex" justify="start">
          <el-col :span="20" :offset="1">
            <el-form-item>
              <el-upload
                class="upload-demo"
                ref="upload"
                action=""
                accept=".jpeg,.jpg,.png"
                :http-request="upload"
                :before-upload="beforeUpload"
                limit="1"
                list-type="picture"
                :auto-upload="false"
              >
                <el-button slot="trigger" size="small" type="primary">上传图片</el-button>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <el-footer style="text-align: right;padding-top: 10px;">
        <el-button size="small" @click="editFormVisible = false">取 消</el-button>
        <el-button style="margin-left: 10px;" size="small" type="primary" @click="submitUpload">确定</el-button>
      </el-footer>
    </el-dialog>
    <!-- 查看图片弹窗 -->
    <el-dialog title="图片查看" :visible.sync="imgFormVisible" :close-on-click-modal="false" width="50%" v-esc-close><imgShow :imgList="imgList"></imgShow></el-dialog>

    <!-- 上传图片弹窗 -->
    <el-dialog title="上传视频及图片" :visible.sync="imgUploadFormVisible" :close-on-click-modal="false" width="60%">
      <imgUpload @save="saveImg" @cancel="imgUploadFormVisible = false" :imgListProp="imgListProp" :typeProp="upType" :disableVideo="true"></imgUpload>
    </el-dialog>
    <custom-table v-model="tableVisible" :tableDataSet="tableDataSet" v-if="tableVisible" @closeAddForm="closeAddForm" @confirm="confirm"></custom-table>
  </div>
</template>

<script>
import PeriodCell from '@/views/shippingPeriod/components/PeriodCell';
import { withPeriodColumn } from '@/views/shippingPeriod/masterColumns';
import imgShow from '@/views/components/imgShow';
import imgUpload from '@/views/components/imgUpload';

import { FILE_TYPE } from '@/utils/Global';
import axios from '@/utils/axiosInstance';
import customPropsMixin from './customProps.mixin'
import pagePathMixin from '@/utils/page-path-mixin'
import tableMixin from '@/utils/tableMixin'

export default {
  components: { imgShow, imgUpload, PeriodCell },
  name: 'goodsList',
  mixins: [customPropsMixin, pagePathMixin, tableMixin],
  data() {
    return {
      loading: false,
      loadingExport: false,
      imgUrl: '',
      tableData: {
        records: [],
        pageNum: 1,
        pageSize: 30,
        total: 0
      },
      searchForm: {
        filterData: {}
      },
      addData: {},
      editData: {},
      editFormVisible: false,
      imgFormVisible: false,

      checkAll: false,
      propCheckAll: false,
      isIndeterminate: false,
      checkStores: [],
      stores: [],
      clearanceStatus: [],
      styleList: [],
      categoryList: [],
      aClassSelect: [],
      goodsAttrLocationSelect: [],
      goodsLocationSelect: [],
      goodsPlaceSelect: [],
      types: [],
      shopOptions: [],

      // 图片弹窗
      imgFormVisible: false,
      imgList: [],

      // 图片上传弹窗
      imgUploadFormVisible: false,
      upType: 0,
      currentRow: [],
      imgListProp: [],
      tableReload: true,
      columnsData: [],
      saleStatusList: [],
      marketOnDateRange: [], 
    };
  },
  computed: {
    periodColumns() { return withPeriodColumn(this.columnData, '商品名称'); },
  },
  watch: {
    $route: {
      handler(val, olv) {
        var query = val.query ? val.query : {};
        if (
          olv.path == '/dataBoard/newProductStatistics' &&
          (query.marketOnBegin != this.searchForm.filterData.marketOnBegin ||
          query.marketOnEnd != this.searchForm.filterData.marketOnEnd) &&
          JSON.stringify(val.query) != '{}'
        ) {
          this.searchForm.filterData.marketOnBegin = query.marketOnBegin;
          this.searchForm.filterData.marketOnEnd = query.marketOnEnd;
          this.onSearch();
        }
      },
    },
  },
  methods: {
    // screen(val) { //筛选
    //   if (this.propList.length == this.allPropList.length) {
    //     this.propCheckAll = true;
    //   } else {
    //     this.propCheckAll = false;
    //   }
    //   let change = val.map(v=>v.prop) 
    //   let columnsData = this.columnsData.sysColumns
    //   let data = columnsData.filter(v=>change.includes(v.columnName))
    //   this.$q.goods.operate({ data: data}).then(res => {
    //     // console.log(res);
    //   });
    // },  
    onSearch() {
      delete this.searchForm.filterData.deliveryCycle;
      this.searchForm.pageNum = this.tableData.pageNum;
      this.searchForm.pageSize = this.tableData.pageSize;
      this.searchForm.filterData.storeIds = this.checkStores;
      this.searchForm.exportTag = false;
      this.loading = true;
      this.$q.goods.goodsListPage({ data: JSON.stringify(this.searchForm) }).then(res => {
        this.tableData = this.dataFormat(res.data);
        this.loading = false;
      });
     
    },
    criteriaSearch() {
      this.tableData.pageNum = 1;
      this.onSearch();
    },
    // 获取风格下拉选项
    getOptionType() {
      this.$q.goods.goodsQueryOptionType().then(res => {
        this.stores = res.data.storeList;
        this.clearanceStatus = res.data.saleStatusList;
        this.styleList = res.data.styleList;
        this.categoryList = res.data.categoryList;
      });
    },
    // A类下拉数据
    // get_aClassSelect() {
    //   this.$q.goods.aClassSelect().then(res => {
    //     this.aClassSelect = res.data;
    //   });
    // },
    // (商品属性维护页面搜索)商品定位下拉数据
    get_goodsAttrLocationSelect() {
      this.$q.goods.goodsAttrLocationSelect().then(res => {
        this.goodsAttrLocationSelect = res.data;
      });
    },
    // (sku搜索页面搜索)商品定位下拉数据
    get_goodsLocationSelect() {
      this.$q.goods.goodsLocationSelect().then(res => {
        this.goodsLocationSelect = res.data;
      });
    },
    // 商品空间下拉数据
    get_goodsPlaceSelect() {
      this.$q.goods.goodsPlaceSelect().then(res => {
        this.goodsPlaceSelect = res.data;
      });
    },

    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.onSearch();
    },

    handleSizeChange(val) {
      this.tableData.pageNum = 1;
      this.tableData.pageSize = val;
      this.onSearch();
    },

    onDateRangeChange(val) {
      if (val && val.length === 2) {
        this.searchForm.filterData.marketOnBegin = val[0];
        this.searchForm.filterData.marketOnEnd = val[1];
      } else {
        this.searchForm.filterData.marketOnBegin = '';
        this.searchForm.filterData.marketOnEnd = '';
      }
    },

    getEditData(row) {
      this.editData = JSON.parse(JSON.stringify(row));
      if (row.imgUrl) {
        this.$refs.upload1.clearFiles(); // 清空
      } else {
        this.$refs.upload2.clearFiles(); // 清空
      }
    },
    editClose() {
      this.$refs.upload.clearFiles(); // 清空
    },
    // 查看图片
    viewImg(row) {
      this.imgFormVisible = true;
      this.imgList = [];
      const list = row.imgUrlList;
      for (const item of list) {
        this.imgList.push(item.path);
      }
    },

    // 显示图片上传
    showUpload(row, type) {
      this.currentRow = row;
      this.imgListProp = [...row.imgUrlList];
      this.imgUploadFormVisible = true;
      this.upType = type;
    },

    // 保存已上传的图片
    saveImg(data) {
      this.imgUploadFormVisible = false;
      for (let s of data) {
        s.relationId = this.currentRow.goodsId;
      }
      this.editData = { imgList: data, code: this.currentRow.goodsCode };
      this.editDeliveryCycle();
    },
    delImg(code) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$q.goods
          .imgDelete({ data: JSON.stringify({ goodsCode: code }) })
          .then(res => {
            this.$message.success('删除成功');
            this.onSearch();
          })
          .catch(error => {
            this.$message.error(error.message);
          });
      });
    },
    editDeliveryCycle() {
      this.$q.goods
        .imgEdit({ data: JSON.stringify(this.editData) })
        .then(res => {
          this.editData = {};
          this.onSearch();
          this.$message.success('操作成功');
        })
        .catch(error => {
          this.$message.error(error.message);
        });
    },

    handleCheckAllChange(val) {
      let ids = [];
      for (let item of this.stores) {
        ids.push(item.id);
      }
      this.checkStores = val ? ids : [];
      this.isIndeterminate = false;
    },
    handleCheckedStoreChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.stores.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.stores.length;
    },

    upload(param) {
      this.$q.common
        .uploadFile({ data: { file: param.file } })
        .then(res => {
          this.editData.imgUrl = res.data;
          this.editDeliveryCycle();
        })
        .catch(error => {
          this.$message.error(error.message);
        });
    },
    // 上传
    submitUpload() {
      this.$refs.upload.submit();
    },

    // 文件类型验证
    beforeUpload(file) {
      // .jpeg,.jpg,.png
      let pattern = file.name.substring(file.name.indexOf('.') + 1);
      if (['png', 'jpg', 'jpeg'].indexOf(pattern.toLowerCase()) === -1) {
        this.$message.error('请上传后缀名为.png  .jpg  .jpeg的图片！');
        return false;
      }
    },

    // 导出
    exportExcel() {
      // this.searchForm.pageNum = 1;
      // this.searchForm.pageSize = 2147483647;
      // this.searchForm.exportTag = true;
      //   let params = {
      //      appCode: "ec-pc-api",
      //      paramMap:{
      //        ...this.searchForm.filterData
      //      },
      //      reportName: "skuExport"     
      //   }
      //   console.log(this.searchForm)
      //   console.log(params)
      //    this.$q.common.exportExcel({data: params}).then(res => {
      //     if (res.success) {
      //      this.$message.success('提交下载任务成功，请稍后到导出列表查阅！');
      //      } else {
      //         this.$message.error(res.message);
      //     }                     
      //   })

      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let params = {
        taskDTO: {
          appCode: "ec-pc-api",
          // 数据过滤
          paramMap: {
            exportTag: true,
            ...this.searchForm.filterData
          },
          reportName: "skuExport"
        },
        // 配置导出列
        columnDTOs: [
          {
            columnName: '状态',
            parentColumnName: null,
            fieldName: 'adapterMattress',
            fieldType: 'string',
            columnFormat: null
          }
        ]
      };
      let labels = this.columnData.map(v=>v.label);
      let props = this.columnData.map(v=>v.prop);
      props.forEach((prop, index) => {
        params.columnDTOs.push({
          columnName: labels[index],
          parentColumnName: null,
          fieldName: prop,
          fieldType: 'string',
          columnFormat: null
        })
      })
      // 不导出图片列
      params.columnDTOs = params.columnDTOs.filter(v=>v.columnName !== '图片');
      this.$q.common.customExportExcel({data: params}).then((res) => {
        console.log(res)
        loading.close();
        this.$message({
          type: "success",
          message: "导出成功,请在导出列表中查看",
        });
      });

    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },

    reset() {
      this.checkAll = false;
      this.isIndeterminate = false;
      this.checkStores = [];
      this.searchForm.filterData = {};
      this.tableData.pageNum = 1;
      this.onSearch();
    },
    clearImg() {
      this.imgUrl = null;
    },
    dataFormat(data) {
      let list = data.records;
      for (let item of list) {
        item.combination ? (item.combination = '是') : (item.combination = '否');
        // item.clearance ? (item.clearance = '是') : (item.clearance = '否');
      }
      data.records = list;
      return data;
    },

    // 导入
    importExcel() {
      // 核心语句
      this.openSubPage({
        path: '/importExcel',
        name: 'ImportExcel',
        query: {
          // 路由传参时push和query搭配使用 ，作用时传递参数
          fileType: FILE_TYPE.SKU导入,
          fileName: 'SKU导入.xlsx'
        }
      });
    },
    // 图片导入
    importImg() {
      // 核心语句
      this.openSubPage({
        path: '/importImg',
        name: 'ImportImg', // 跳转的路径
        query: {
          // 路由传参时push和query搭配使用 ，作用时传递参数
          fileType: FILE_TYPE.商品图片
        }
      });
    },
    beginDate(date) {
      return {
        disabledDate(time) {
          time.setHours(-8);
          // 如果结束时间不为空，则小于结束时间
          if (date) {
            return new Date(date).getTime() < time.getTime();
          } else {
            // return time.getTime() > Date.now()//开始时间不选时，结束时间最大值小于等于当天
          }
        }
      };
    },
    processDate(date) {
      return {
        disabledDate(time) {
          time.setHours(8);
          // 如果开始时间不为空，则结束时间大于开始时间
          if (date) {
            return new Date(date).getTime() > time.getTime();
          } else {
            // return time.getTime() > Date.now()//开始时间不选时，结束时间最大值小于等于当天
          }
        }
      };
    },
    // 表头样式设置
    headClass() {
      return 'text-align: center;background:#eef1f6;';
    },
    // 表格样式设置
    rowClass() {
      return 'text-align: center;';
    },
    // 所属店铺
    get_shopOptions() {
      this.$q.product.storeSelect()
      .then(res=>{
        this.shopOptions = res.data;
      })
    },
    // 所属类型
    get_types() {
      this.$q.product.getType()
      .then(res=>{
        this.types = res.data;
      })
    },
    getSaleStatusList() {
      let data = {
        pageSize: 999,
        pageNum: 1,
        reportCode: 'goodsSaleStatusList',
        queryMatch: [],
        hasCount: 'Y',
      };
      axios
        .post(`/ec-pc-api/custom/reports/data/goodsSaleStatusList`, data)
        .then((res) => {
          if (res.code == 200) {
            this.saleStatusList = res.data.list;
          }
        })
    }
  },

  mounted() {
    this.searchForm.filterData = {
      saleStatus: '',
      goodsLocation: '',
      space: '',
      category: '',
      combination: '',
      style: '',
      clearance: '',
      imgExist: '',
      type: '',
      aclass: '',
      containsPine: '',
      goodsCodeError: '',
      shelfRemoveFlag: '',
    }
    let query = this.$route.query;
    if (query.marketOnBegin && query.marketOnEnd) {
      this.searchForm.filterData.marketOnBegin = query.marketOnBegin;
      this.searchForm.filterData.marketOnEnd = query.marketOnEnd;
    }
    this.getOptionType();
    this.getSaleStatusList();
    // this.get_aClassSelect();
    this.get_goodsAttrLocationSelect();
    this.get_goodsLocationSelect();
    this.get_goodsPlaceSelect();
    this.onSearch();
    this.get_shopOptions();
    this.get_types();
  }
};
</script>

<style lang="stylus" scoped>
.inline-block
  display inline-block
.table-wrap
  padding 10px
  .wrap_tooltip
    display inline-block
    max-width 200px
    overflow hidden
    text-overflow ellipsis
    white-space nowrap
    cursor pointer

>>> .checkbox
    width 100%

>>> .checkbox .el-form-item__content
  width 90%

.search-box
  >>> .search-left
    min-height 100px
</style>
